export const setCookie = (name: string, value: string, expires: Date) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
};

export const removeCookie = (name: string) => {
  const date = new Date(0); // Set to a past date
  document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
};
